module.exports = __webpack_public_path__ + "static/media/chevron.c0f955a8.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/promos/chevron.svg
// module id = 486
// module chunks = 0